import styled from "styled-components";

export default function ForwardTo({ intl }) {
  return (
    <Wrapper>

      {intl.formatMessage({
        id: "common.forward_to",
        defaultMessage: "游戏公测已结束，正式版即将发布，\n敬请期待！",
      })}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: #000000;
  text-align: center;
  span {
    color: #ff5c00;
  }
`;
